<!-- One undo-toast template is generated per pending soft-delete via @for.
     Each template closes over its own pending.notificationId so concurrent
     toasts each undo exactly the right notification. -->
@for (pending of pendingDeletes; track pending.notificationId) {
<ng-template #undoToastTemplate [caLocalizationScope]="localizationScope">
  {{ 'notificationDeleted' | caLocalize }}
  <button
    class="btn btn-link link link-main ms-2 p-0"
    type="button"
    (click)="onUndoToast(pending.notificationId)"
    data-automation-id="undo-delete-btn"
  >
    {{ 'undo' | caLocalize }}
  </button>
</ng-template>
}

<div
  class="notifications-drawer d-flex flex-column h-100"
  [caLocalizationScope]="localizationScope"
  data-automation-id="notifications-drawer"
>
  @let loading = loading$ | async; @let error = error$ | async; @let categories = categories$ | async; @if (loading) {
  <!-- Loading State -->
  <div class="flex-grow-1 d-flex justify-content-center align-items-center p-5" data-automation-id="loading-state">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'loading' | caLocalize }}</span>
    </div>
  </div>
  } @else if (error) {
  <!-- Error State -->
  <div
    class="flex-grow-1 d-flex flex-column align-items-center justify-content-center p-4 text-center"
    data-automation-id="error-state"
  >
    <i class="f-i f-i-warning f-i-lg text-warning mb-2"></i>
    <p class="text-muted mb-2">{{ 'loadingError' | caLocalize }}</p>
    <button class="btn btn-sm btn-outline-primary" type="button" (click)="onRetry()" data-automation-id="retry-btn">
      {{ 'retry' | caLocalize }}
    </button>
  </div>
  } @else if (categories) {
  <!-- Categories Tabs -->
  @if (categories.length === 0 || !hasAnyNotifications(categories)) {
  <!-- Empty State -->
  <div
    class="flex-grow-1 d-flex flex-column align-items-center justify-content-center p-4 text-center"
    data-automation-id="empty-state"
  >
    <i class="f-i f-i-bell f-i-lg text-muted mb-2"></i>
    <p class="text-muted">{{ 'noNotifications' | caLocalize }}</p>
  </div>
  } @else {
  <!-- Tabs -->
  <div class="flex-grow-1 overflow-auto pt-5">
    <nav
      ngbNav
      #categoriesNav="ngbNav"
      [(activeId)]="activeTabId"
      class="nav-tabs nav-tabs-sm"
      data-automation-id="category-tabs"
    >
      @for (cat of categories; track cat.category) {
      <ng-container [ngbNavItem]="cat.category">
        <a ngbNavLink [attr.data-automation-id]="'tab-' + cat.category">
          {{ cat.category | lowercase | caLocalize }}
          @if (cat.unreadCount > 0) {
          <span class="ms-1" data-automation-id="category-unread-count">({{ cat.unreadCount }})</span>
          }
        </a>

        <ng-template ngbNavContent>
          <div
            class="notification-category-content pt-4 d-flex flex-column gap-4"
            [attr.data-automation-id]="'category-content-' + cat.category"
          >
            @for (typeNotifications of cat.notificationsByType; track typeNotifications.notificationTypeCode) { @if
            (typeNotifications.totalCount > 0) {
            <ca-notification-type-list
              [notificationsByType]="typeNotifications"
              [typePageState]="(getTypePageState(typeNotifications.notificationTypeCode) | async) ?? undefined"
              (loadMore)="onLoadMore($event)"
              (markAsRead)="onMarkAsRead($event)"
              (delete)="onDelete($event)"
            >
            </ca-notification-type-list>
            } }
          </div>
        </ng-template>
      </ng-container>
      }
    </nav>

    <div [ngbNavOutlet]="categoriesNav"></div>
  </div>
  } }

  <!-- Footer: Go to Data Alerts  -->
  <div
    class="d-flex justify-content-center border-top pt-3 pb-2 flex-shrink-0"
    data-automation-id="notifications-footer"
  >
    <a class="link link-main" type="button" (click)="navigateToDataAlerts()" data-automation-id="go-to-data-alerts-btn">
      {{ 'goToDataAlerts' | caLocalize }}
    </a>
  </div>
</div>
